import { createSelector } from 'reselect';
import { get } from 'lodash';

/**
 * Direct selector to the SurveyTranslationPage state domain
 */
const selectSurveyTranslationsDomain = (state) =>
  get(state, 'surveyTranslationPage');
const selectSurveySelectedLanguage = (state) =>
  get(state, 'surveyTranslationPage.selectedLanguage');
const selectSurveyTranslations = (state) =>
  get(state, 'surveyTranslationPage.translations');

/**
 * Other specific selectors
 */

/**
 * Default selector used by SurveyTranslationPage
 */

const makeSelectSurveyTranslationPage = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate,
);
const makeSelectTranslations = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.translations,
);
const makeSelectLanguages = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.languages,
);
const makeSelectTranslateOpenEnded = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => (substate ? substate.translateOpenEnded : {}),
);

const makeSelectEditVersion = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.editVersion,
);

const makeSelectSavedEditVersion = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.savedEditVersion,
);

const makeSelectIsSaving = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.isSaving,
);
const makeSelectIsFetching = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.isFetching,
);
const makeSelectErrors = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.errors,
);

const makeSelectGoogleTranslateModal = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.googleTranslateModal,
);

const makeSelectHasImportedTranslations = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.hasImportedTranslations,
);

const makeSelectGoogleTranslatedLanguages = createSelector(
  selectSurveyTranslationsDomain,
  (substate) => substate.googleTranslatedLanguages,
);

export default makeSelectSurveyTranslationPage;
export {
  makeSelectEditVersion,
  makeSelectSavedEditVersion,
  makeSelectIsSaving,
  makeSelectIsFetching,
  makeSelectErrors,
  makeSelectTranslateOpenEnded,
  makeSelectTranslations,
  makeSelectLanguages,
  selectSurveyTranslations,
  selectSurveySelectedLanguage,
  makeSelectGoogleTranslateModal,
  makeSelectHasImportedTranslations,
  makeSelectGoogleTranslatedLanguages,
};
